import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { PromoPageContainer } from 'components/no-auth/common/PromoPageContainer/PromoPageContainer';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import { HighlightedTilesSection } from 'components/no-auth/common/sections/HighlightedTilesSection';
import { ListingTilesSection } from 'components/no-auth/common/sections/ListingTilesSection';
import { QuoteSectionV2 } from 'components/no-auth/common/sections/QuoteSectionV2';
import { TilesSection } from 'components/no-auth/common/sections/TilesSection';
import VideoSectionV2 from 'components/no-auth/common/sections/VideoSectionV2';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

const BusinessEnterpriseLandingPageV2 = (props) => {
    return (
        <PromoPageContainer bgColor="eggshell02" noIndent>
            {props.heroTitle && (
                <HeroSection
                    title={props.heroTitle}
                    text={props.heroText}
                    img={props.heroImg}
                    btnVariant="primary"
                    noIconBtn
                    horizontalLayout
                    data={props.heroData}
                    fetchPriorityHigh
                />
            )}
            <ColoredSectionContainer>
                {props.benefits && <HighlightedTilesSection data={props.benefits} />}
                {props.headlineInstantPayoutTitle && <HeadingSection title={props.headlineInstantPayoutTitle} text={props.headlineInstantPayoutText} />}
                {props.offers && <HighlightedTilesSection data={props.offers} />}
                {props.tilesTitle && <HeadingSection title={props.tilesTitle} text={props.tilesText} />}
                {props.tilesSection1 && <TilesSection lang={props.lang} country={props.country} data={props.tilesSection1} loadingLazy />}
                {props.marketfitTitle && <HeadingSection title={props.marketfitTitle} text={props.marketfitText} />}
                {props.team && <ListingTilesSection data={props.team} loadingLazy />}
            </ColoredSectionContainer>
            <ColoredSectionContainer>
                {props.quote && <QuoteSectionV2 data={props.quote} />}
                {props.apiTitle && <HeadingSection title={props.apiTitle} text={props.apiText} btn={props.apiBtn} isMobileBtn={props.apiBtnIsMobileBtn} />}
            </ColoredSectionContainer>
            {props.videoUrl && (
                <VideoSectionV2
                    sectionTitle={props.videoTitle}
                    btn={props.videoBtn}
                    videoUrl={props.videoUrl}
                    videoPreviewImg={props.videoPreviewImg}
                    videoTitle={props.videoTitle}
                />
            )}
            {props.getstartedTitle && (
                <ColoredSectionContainer bottomPadding>
                    <HeadingSection
                        title={props.getstartedTitle}
                        text={props.getstartedText}
                        btn={props.getstartedBtn}
                        isMobileBtn={props.getstartedBtnIsMobileBtn}
                        noBottomIndent
                    />
                </ColoredSectionContainer>
            )}
        </PromoPageContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroImg: state.extra?.strapiApi?.hero_block?.img,
        heroData: state.extra?.strapiApi?.hero_block,

        benefits: state.extra?.strapiApi?.tiles_highlighted,

        offers: state.extra?.strapiApi?.tiles_highlighted2,

        headlineInstantPayoutTitle: state.extra?.strapiApi?.headline1?.title,
        headlineInstantPayoutText: state.extra?.strapiApi?.headline1?.text,

        tilesTitle: state.extra?.strapiApi?.headline2?.title,
        tilesText: state.extra?.strapiApi?.headline2?.text,

        marketfitTitle: state.extra?.strapiApi?.headline3?.title,
        marketfitText: state.extra?.strapiApi?.headline3?.text,

        team: state.extra?.strapiApi?.team_section,

        apiTitle: state.extra?.strapiApi?.headline4?.title,
        apiText: state.extra?.strapiApi?.headline4?.text,
        apiBtn: state.extra?.strapiApi?.headline4?.btn,
        apiBtnIsMobileBtn: state.extra?.strapiApi?.headline4?.isMobileBtn,

        getstartedTitle: state.extra?.strapiApi?.headline5?.title,
        getstartedText: state.extra?.strapiApi?.headline5?.text,
        getstartedBtn: state.extra?.strapiApi?.headline5?.btn,
        getstartedBtnIsMobileBtn: state.extra?.strapiApi?.headline5?.isMobileBtn,

        tilesSection1: state.extra?.strapiApi?.tiles_section1,

        quote: state.extra?.strapiApi?.quote_section,

        lang: state.extra.noAuthFooter?.language?.lang,
        country: state.extra.noAuthFooter?.language?.country,

        videoTitle: state.extra?.strapiApi?.video_section?.title,
        videoUrl: state.extra?.strapiApi?.video_section?.url,
        videoBtn: state.extra?.strapiApi?.video_section?.btn,
        videoPreviewImg: state.extra?.strapiApi?.video_section?.img,
    };
};
export default connect(mapStateToProps)(NotAuthBasePage(BusinessEnterpriseLandingPageV2));
